// extracted by mini-css-extract-plugin
export default {"padding":"0","default-padding":"_33U2o","defaultPadding":"_33U2o"};